import { paymentForm } from './elements'
import { formSubmit } from './submit'

paymentForm?.addEventListener("submit", formSubmit);
